export default __webpack_public_path__ + "src/assets/sounds/raise-hand.wav";